import React, { memo } from 'react';
import withProjectParams from 'utils/hocs/withProjectParams';
import PropTypes from 'prop-types';
import { HotKeys as ReactHotKeys } from 'react-hotkeys';
import useNavigationShortcuts from './hooks';

const NavigationShortcuts = memo(props => {
  const {
    company,
    project,
    history: { push },
  } = props;

  const url = `/${company}/${project}`;

  const { handlers, shortcuts } = useNavigationShortcuts(url, push);

  return (
    <ReactHotKeys handlers={handlers} keyMap={shortcuts}>
      {props.children}
    </ReactHotKeys>
  );
});

NavigationShortcuts.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  company: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  project: PropTypes.string.isRequired,
};

export default withProjectParams(NavigationShortcuts);
